import { candidateConstants } from "../../_constants";

const initialState = {};

// candidate reducer
export const create_candidate_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.CREATE_CANDIDATE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.CREATE_CANDIDATE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        data: action.payload,
      };
    case candidateConstants.CREATE_CANDIDATE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// update candidate reducer
export const update_candidate_profile_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userData: action.payload,
      };
    case candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate profile
export const get_candidate_profile_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_SUCCESS:
    case candidateConstants.UPDATE_CANDIDATE_PROFILE_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userProfileData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PROFILE_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

//candidate intro
export const get_candidate_intro_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userIntro: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INTRO_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate education
export const get_candidate_all_educational_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userEducationalData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_EDUCATIONAL_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate education by id
export const get_candidate_education_by_id_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userEducationByIdData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate profession
export const get_candidate_all_professional_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userProfessionalData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_PROFESSIONAL_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate profession by id
export const get_candidate_profession_by_id_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userProfessionByIdData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// candidate skills
export const get_candidate_all_skills_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userSkillsData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_SKILLS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

export const create_candidate_skills_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        newUserSkillData: action.payload,
      };
    case candidateConstants.CREATE_CANDIDATE_SKILLS_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};



// candidate portfolio
export const get_candidate_all_portfolio_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_SUCCESS:
      return {
        type: "alert-success",
        userPortfolioData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ALL_PORTFOLIO_DATA_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};



// candidate reducer
export const get_candidate_invited_jobs_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        invitedJobsData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INVITED_JOBS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


// candidate reducer
export const get_candidate_suggested_jobs_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        suggestedJobsData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_SUGGESTED_JOBS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};


export const get_candidate_pending_task_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_SUCCESS:
      return {
        type: "alert-success",
        pendingTaskData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_PENDING_TASK_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
export const get_candidate_interview_invites_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        interviewInvitesData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_INVITED_INTERVIEWS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
export const get_candidate_accepted_interviews_reducer = (state = initialState, action) => {
  switch (action.type) {
    case candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        acceptedInterviewData: action.payload,
      };
    case candidateConstants.GET_CANDIDATE_ACCEPTED_INTERVIEWS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};